<template>
    <el-row>
        <div class="search-set">
            <ul class="search-list-box">
                <template v-for="(outer, pIndex) in searchList">
                    <li
                        v-for="item in outer.list"
                        :key="item.name + pIndex"
                        :class="{ 'is-fussy': item.isFussy }"
                    >
                        <span class="label overflow-text" :title="item.name">{{
                            item.name
                        }}</span>
                        <el-select
                            :disabled="
                                ['time', 'inputRange'].includes(item.type)
                            "
                            v-model="item.detailType"
                            placeholder="请选择"
                            class="select"
                        >
                            <el-option label="等于" value="0"></el-option>
                            <el-option label="不等于" value="1"></el-option>
                            <el-option
                                disabled
                                label="范围"
                                value="2"
                            ></el-option>
                        </el-select>
                        <div class="form-item">
                            <el-input
                                class="text-box"
                                v-if="item.type === 'advanceUser'"
                                v-model="outer.data[item.value]"
                                readonly
                                @keyup.113.native="
                                    userDetaliSearch(pIndex, item)
                                "
                                @keyup.enter.native="
                                    userDetaliSearch(pIndex, item)
                                "
                                @blur="userDetaliSearch(pIndex, item)"
                                @input="advanceCodeChange(pIndex, item)"
                                @clear="advanceCodeChange(pIndex, item)"
                                :disabled="showState"
                            >
                                <template v-slot:append>
                                    <el-button
                                        :disabled="showState"
                                        @click="userDetaliSearch(pIndex, item)"
                                        icon="el-icon-search"
                                    ></el-button>
                                </template>
                                <template v-slot:suffix>
                                    <i
                                        :disabled="showState"
                                        @click="resetAdvanceParams(item.value)"
                                        class="
                                            el-input__icon
                                            el-icon-circle-close
                                        "
                                        v-if="outer.data[item.value]"
                                    ></i>
                                </template>
                            </el-input>
                            <el-input
                                class="text-box"
                                v-if="item.type === 'advance'"
                                v-model="item.chooseValueName"
                                readonly
                                @keyup.113.native="detaliSearch(pIndex, item)"
                                @keyup.enter.native="detaliSearch(pIndex, item)"
                                @blur="detaliSearch(pIndex, item)"
                                @input="advanceCodeChange(pIndex, item)"
                                @clear="advanceCodeChange(pIndex, item)"
                                :disabled="showState"
                            >
                                <template v-slot:append>
                                    <el-button
                                        :disabled="showState"
                                        @click="detaliSearch(pIndex, item)"
                                        icon="el-icon-search"
                                    ></el-button>
                                </template>
                                <template v-slot:suffix>
                                    <i
                                        :disabled="showState"
                                        @click="
                                            resetAdvanceParams(item.value, item)
                                        "
                                        class="
                                            el-input__icon
                                            el-icon-circle-close
                                        "
                                        v-if="item.chooseValueName"
                                    ></i>
                                </template>
                            </el-input>
                            <el-input
                                class="text-box"
                                :disabled="showState"
                                v-if="item.type === 'input'"
                                v-model="item.chooseValueCode"
                            >
                            </el-input>
                            <el-select
                                class="text-box"
                                v-model="item.chooseValueCode"
                                v-if="item.type === 'select'"
                                :clearable="_.get(item, 'clearable', true)"
                                :multiple="
                                    item.multiple ? item.multiple : false
                                "
                                :filterable="item.filterable"
                                :disabled="showState"
                                collapse-tags
                            >
                                <el-option
                                    v-for="(val, index) in item.options"
                                    :key="index"
                                    :label="val.label"
                                    :value="val.value"
                                >
                                </el-option>
                            </el-select>
                            <el-select
                                v-else-if="item.type === 'autocomplete'"
                                :clearable="_.get(item, 'clearable', true)"
                                v-model="
                                    outer.data[
                                        item.passValue
                                            ? item.passValue
                                            : item.value
                                    ]
                                "
                                filterable
                                remote
                                :multiple="
                                    item.multiple ? item.multiple : false
                                "
                                reserve-keyword
                                :placeholder="item.name"
                                :remote-method="remoteMethod"
                                @focus="searchDateChange(item)"
                                :loading="searchLoading"
                                :disabled="showState"
                                collapse-tags
                            >
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                            <addressSelect
                                class="text-box"
                                v-if="item.type === 'addressSelect'"
                                v-model="outer.data[item.value]"
                                :minLayers="item.minLayers"
                                :placeholder="item.name"
                                :basicProps="item.config"
                            ></addressSelect>
                            <addressCascader
                                class="text-box"
                                v-if="item.type === 'addressCascader'"
                                v-model="outer.data[item.value]"
                                :minLayers="item.minLayers"
                                :placeholder="item.name"
                                :basicProps="item.config"
                                :triggerEvent="'hover'"
                            >
                            </addressCascader>
                            <el-date-picker
                                class="text-box"
                                v-if="item.type === 'time'"
                                v-model="item.chooseValueCode"
                                :clearable="_.get(item, 'clearable', true)"
                                :disabled="showState"
                                size="mini"
                                format="yyyy-MM-dd HH:mm:ss"
                                :value-format="
                                    item.format || 'yyyy-MM-dd HH:mm:ss'
                                "
                                :type="
                                    item.time ? 'daterange' : 'datetimerange'
                                "
                                unlink-panels
                                range-separator="至"
                                :start-placeholder="
                                    item.startPlaceholder
                                        ? item.startPlaceholder
                                        : '开始日期'
                                "
                                :end-placeholder="
                                    item.endPlaceholder
                                        ? item.endPlaceholder
                                        : '结束日期'
                                "
                                :picker-options="pickerOptions"
                                :default-time="['00:00:00', '23:59:59']"
                            >
                            </el-date-picker>
                            <div
                                v-if="item.type === 'inputRange'"
                                class="text-boxs"
                            >
                                <el-input
                                    class="text-input"
                                    v-model.trim="item[item.range[0]]"
                                    :disabled="showState"
                                    oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
                                ></el-input>
                                至
                                <el-input
                                    class="text-input"
                                    v-model.trim="item[item.range[1]]"
                                    :disabled="showState"
                                    oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+4)}"
                                ></el-input>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <div v-if="!showState" class="btn-box1">
                <div class="text-btn">
                    <el-button type="text" @click="showStateOpen"
                        >自定义筛选条件</el-button
                    >
                </div>
                <div class="btn-btn">
                    <el-button type="text" @click="clear">重 置</el-button>
                </div>
            </div>
            <div v-if="showState" class="showState">
                <p class="line"></p>
                <div>选择添加筛单条件</div>
                <el-tabs v-model="activeName">
                    <el-tab-pane label="全 部" name="first">
                        <ul class="search-total-box">
                            <li
                                v-for="(item, index) in searchTotalTitle"
                                :key="index"
                            >
                                <el-button
                                    class="btn-width overflow-text"
                                    plain
                                    :style="searchSelect[item.name]"
                                    @click="btnChange(item.name)"
                                    >{{ item.name }}</el-button
                                >
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="常 用" name="second">
                        <ul class="search-total-box">
                            <li
                                v-for="(item, index) in commonTitle"
                                :key="index"
                            >
                                <el-button
                                    class="btn-width overflow-text"
                                    plain
                                    :style="searchSelect[item.name]"
                                    @click="btnChange(item.name)"
                                    >{{ item.name }}</el-button
                                >
                            </li>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
                <div class="btn-box">
                    <el-button @click="cancelSearch">取消</el-button>
                    <el-button type="primary" @click="saveSearch"
                        >保存</el-button
                    >
                </div>
            </div>
        </div>
        <advance-dialog
            ref="advanceDialog"
            @confirm="detaliSearchSure"
        ></advance-dialog>
        <advance-user
            ref="advanceUser"
            @confirm="detaliSearchSure"
        ></advance-user>
    </el-row>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import _ from '@/components/lots/utils';
import { longRange, dict, getList } from '@/components/otpPanel/api';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import advanceUser from '@/components/lots/otpAdvanceUser';
import addressSelect from '@/components/lots/otpCascader2';
import addressCascader from '@/components/lots/addressCascader';
import { I18nMixins } from '@/components/utils/i18n';
import { getTransportChooseAndDetail } from '../../../../../api/sieveSingleRule';
export default {
    mixins: [I18nMixins],
    components: { advanceDialog, addressSelect, advanceUser, addressCascader },
    props: {
        popPrefix: String,
        advancePrefix: String,
        longPrefix: String,
        searchTotalTitles: {
            type: Array,
            default () {
                return [];
            }
        },
        searchInitList: {
            type: Array,
            default () {
                return [];
            }
        },
        setSearchData: {
            type: Object,
            default () {
                return {};
            }
        },
        searchId: String,
        id: Number,
        configurationUrl: String,
        filterable: Boolean,
        initSearchInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        searchInitData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            activeName: 'first',
            searchData: {},
            searchChange: [],
            searchSelect: {},
            searchSetList: [],
            selectNum: [],
            showState: false,
            advanceType: 0,
            searchSetTitle: [],
            options: [],
            searchLoading: false,
            selectItem: '',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick (picker) {
                        const start = dayjs().startOf('day').subtract(6, 'd').toDate();
                        const end = dayjs().endOf('day').toDate();
                        picker.$emit('pick', [start, end]);
                        window._paq && window._paq.push(['trackEvent', 'datepicker', 'date', '最近一周']);
                    }
                }, {
                    text: '最近一个月',
                    onClick (picker) {
                        const start = dayjs().startOf('day').subtract(1, 'M').toDate();
                        const end = dayjs().endOf('day').toDate();
                        picker.$emit('pick', [start, end]);
                        window._paq && window._paq.push(['trackEvent', 'datepicker', 'date', '最近一个月']);
                    }
                }, {
                    text: '最近两个月',
                    onClick (picker) {
                        const start = dayjs().startOf('day').subtract(2, 'M').toDate();
                        const end = dayjs().endOf('day').toDate();
                        picker.$emit('pick', [start, end]);
                        window._paq && window._paq.push(['trackEvent', 'datepicker', 'date', '最近两个月']);
                    }
                }]
            },
            keyMap: {},
            resourceCode: '',
            initDataFlag: true,
            searchTotalTitle: [],
            commonTitle: []
        };
    },
    methods: {
        initSearch () {
            const newSearchSetTitle = [];
            this.searchTotalTitle.forEach(item => {
                if ((item.chooseValueCode && item.chooseValueCode.length) || item.chooseValueMin || item.chooseValueMax) {
                    newSearchSetTitle.push(item.name);
                }
            });
            this.searchSetTitle = newSearchSetTitle;
            this.creatSearchList();
            this.selectedShow();
            this.initDataFlag = false;
        },
        deepMenu (node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.fullPath) {
                            this.resourceCode = childrens[i].resourceCode;
                            return childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        btnChange (name) {
            this.searchTotalTitle.forEach(item => {
                if (item.name === name) {
                    item.select = !item.select;
                }
            });
            this.searchSetList = [];
            this.selectedShow();
        },
        cancelSearch () {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
            });
            this.showState = false;
        },
        showStateOpen () {
            if (this.activeName === 'first') {
                const commonTitle = ['线路', '方量', '服务平台', '订单类型', '仓库', '目的地市', '目的地区', '是否分拨订单', '是否模糊订单', '任务类型', '是否下发', '是否仓配分离', '商超标识', '配送方式'];
                this.commonTitle = this.searchTotalTitle.filter(item => commonTitle.includes(item.name));
            }
            if (this.initDataFlag) {
                this.initData();
            } else {
                const menu = { subResources: _.clone(this.menus) };
                this.deepMenu(menu);
            }
            this.showState = true;
        },
        saveSearch () {
            this.showState = false;
            let searchTotalTitle = [];
            let searchTotalName = [];
            this.searchSetList.forEach(data => {
                searchTotalTitle.push(data.name);
                searchTotalName.push(data.value);
            });
            searchTotalTitle = searchTotalTitle.join(',');
            searchTotalName = searchTotalName.join(',');
            const pramas = {
                'configName': searchTotalName,
                'configNameCn': searchTotalTitle,
                'subjectType': this.searchId,
                'moduleCode': this.resourceCode,
                'id': this.user.employeeId
            };
            getList.post(this.configurationUrl, pramas).then(() => {
            }).catch(() => { });
        },
        clear () {
            this.searchReset(null, true);
        },
        search () {
            this.$emit('search', this.searchSetList);
        },
        advanceCodeChange (num, item) {
            this.searchSetList.forEach(i => {
                if (i.value === item.value) {
                    i.chooseValueCode = '';
                    i.chooseValueName = '';
                }
            });
            this.advanceType = num;
            this.currentSearchData[item.advanceCode] = '';
        },
        searchReset (searchDataIn = null, reset = false) {
            if (reset) {
                this.searchTotalTitle.forEach(item => {
                    item.chooseValueCode = '';
                    item.chooseValueName = '';
                    if (item.chooseValueMin || item.chooseValueMax) {
                        item.chooseValueMin = '';
                        item.chooseValueMax = '';
                    }
                });
            }
        },
        searchInit () {
            // 只保存弹窗上存在的元素的属性
            const searchData = this.searchSetList.map(data => {
                // 初始化keyMap
                if (data.type === 'advance' && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
                return data.value;
            }).reduce((result, prop) => {
                if (this.keyMap[prop]) {
                    this.keyMap[prop].forEach(key => {
                        result[key] = this.searchData[key];
                    });
                } else {
                    result[prop] = this.searchData[prop];
                }
                return result;
            }, {});
            this.searchReset(searchData);
        },
        userDetaliSearch (num, current) {
            this.advanceType = num;
            this.$refs.advanceUser.show(current);
        },
        // 高级弹框
        detaliSearch (num, current) {
            this.advanceType = num;
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            const advanceCascade = {};
            if (_.isString(current.advanceCascade)) {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.searchData[sourceProp];
                });
            }
            // 拼接回显数据，tableConfig配置顺序一定是先name后code
            const cache = [];
            if (current.chooseValueCode.length) {
                const code = current.chooseValueCode.split(',');
                const name = current.chooseValueName.split(',');
                name.forEach(item => {
                    cache.push({
                        [current.tableConfig[0].prop]: item
                    });
                });
                cache.forEach((item, index) => {
                    item[current.tableConfig[1].prop] = code[index];
                });
            }
            this.$refs.advanceDialog.show(true, current, advanceCascade, '', cache.length ? cache : undefined);
        },
        detaliSearchSure (data, item) {
            // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
            const keyArr = Object.keys(data);
            if (keyArr.length > 0) {
                keyArr.forEach(key => {
                    this.keyMap[key] = keyArr;
                });
            }
            this.searchSetList.forEach(i => {
                if (i.value === item.value) {
                    i.chooseValueCode = data.chooseValueCode;
                    i.chooseValueName = data[item.value];
                }
            });
            Object.assign(this.currentSearchData, data);
        },
        // 从本地获取上次保存的自定义条件
        getSetList () {
            const menu = { subResources: _.clone(this.menus) };
            this.deepMenu(menu);
            let checkedList = '';
            const pramas = {
                subjectType: this.searchId,
                moduleCode: this.resourceCode,
                id: this.user.employeeId
            };
            return getList.get(this.configurationUrl, pramas).then(data => {
                if (data.data) {
                    checkedList = data.data.configNameCn;
                    this.searchSetTitle = checkedList.split(',');
                } else {
                    this.searchSetTitle = [];
                }
            }).catch(() => {
                this.searchSetTitle = [];
            });
        },
        // 过滤需要展示的条件
        creatSearchList () {
            this.searchSetList = this.searchTotalTitle.map(item => {
                item.select = this.searchSetTitle.includes(item.name);
                return item;
            }).filter(item => item.select);
        },
        remoteMethod (query) {
            this.options = [];
            let searchData;
            if (query) {
                searchData = query.replace(/\s*/g, '');
            } else {
                searchData = '';
            }
            const params = {
                [this.selectItem.tableName]: {
                    [this.selectItem.value]: searchData,
                    [this.selectItem.ganged]: searchData
                }
            };
            if (this.selectItem.relevanceOne) {
                params[this.selectItem.tableName][this.selectItem.relevanceOne] = this.searchData[this.selectItem.relevanceOne];
            }
            if (this.selectItem.relevanceTwo) {
                params[this.selectItem.tableName][this.selectItem.relevanceTwo] = this.searchData[this.selectItem.relevanceTwo];
            }
            longRange(this.longPrefix, params).then(data => {
                const restaurants = [];
                data.data[this.selectItem.tableName].map(search => {
                    restaurants.push({ 'value': search[this.selectItem.ganged], 'label': search[this.selectItem.value] });
                });
                this.searchLoading = true;
                setTimeout(() => {
                    this.searchLoading = false;
                    this.options = restaurants.filter(item => {
                        return item.label.toLowerCase()
                            .indexOf(searchData.toLowerCase()) > -1;
                    });
                }, 20);
            });
        },
        searchDateChange (item) {
            this.selectItem = item;
            this.remoteMethod();
        },
        getOptionList () {
            this.searchTotalTitle.map(columns => {
                if (columns.optionNum) {
                    const params = {
                        dictCodes: columns.optionNum,
                        tenantCode: this.currentTenant.tenantCode
                    };
                    dict(this.popPrefix, params).then(data => {
                        const option = [];
                        for (const key in data.data[columns.optionNum]) {
                            if (data.data[columns.optionNum].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': data.data[columns.optionNum][key] });
                            }
                        }
                        columns.options = option;
                    });
                }
            });
        },
        initData () {
            this.getSetList().then(() => {
                this.creatSearchList();
                this.selectedShow();
            });
        },
        // 选中的自定义条件添加高亮样式
        selectedShow () {
            const searchSetList = [];
            const searchSelect = {};
            this.searchTotalTitle.map((data, index) => {
                const style = {};
                if (data.select === true) {
                    style.color = '#00BCBF';
                    style.borderColor = '#00BCBF';

                    searchSetList.push(data);
                } else {
                    style.color = '#252626';
                    style.borderColor = '#CECECE';
                }
                searchSelect[data.name] = style;
            });
            this.searchSetList = searchSetList;
            this.searchSelect = searchSelect;

            this.searchInit();
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams (prop, item) {
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            keyArr.forEach(key => {
                this.currentSearchData[key] = '';
            });
            this.searchSetList.forEach(i => {
                if (i.value === item.value) {
                    i.chooseValueCode = '';
                    i.chooseValueName = '';
                }
            });
        },
        async getDetailData (id) {
            let transportChooseDetails = [];
            await getTransportChooseAndDetail(id).then(res => {
                if (res && +res.code === 0) {
                    transportChooseDetails = res.data.transportChooseDetail;
                    transportChooseDetails.forEach(item => {
                        item.chooseValue = JSON.parse(item.chooseValue);
                        this.searchTotalTitle.forEach(i => {
                            if (i.chooseKey === item.chooseKey) {
                                i.chooseValueName = item.chooseValue.chooseValueName;
                                i.detailType = item.detailType.toString();
                                if (+item.detailType === 2 && i.type === 'inputRange') {
                                    i.chooseValueMin = item.chooseValue.chooseValueMin;
                                    i.chooseValueMax = item.chooseValue.chooseValueMax;
                                } else if (i.type === 'time') {
                                    i.chooseValueCode = [item.chooseValue.chooseValueMin, item.chooseValue.chooseValueMax];
                                } else if (i.type === 'select' && i.multiple) {
                                    i.chooseValueCode = item.chooseValue.chooseValueCode.split(',');
                                } else {
                                    i.chooseValueCode = item.chooseValue.chooseValueCode;
                                }
                            }
                        });
                    });
                }
            });
        }
    },
    async created () {
        this.searchTotalTitle = _.clone(this.searchTotalTitles);
        this.getOptionList();
        this.searchSelect = Array(this.searchTotalTitle.length).fill({});
        if (this.id) {
            await this.getDetailData(this.id);
            this.initSearch();
        } else {
            this.initData();
        }
    },
    computed: {
        ...mapGetters(['currentTenant', 'menus', 'user']),
        _ () {
            return _;
        },
        searchList () {
            return [
                {
                    list: this.searchInitList,
                    data: this.setSearchData
                },
                {
                    list: this.searchSetList,
                    data: this.searchData
                }];
        },
        currentSearchData () {
            return this.advanceType === 0 ? this.setSearchData : this.searchData;
        }
    }
};

</script>
<style lang="less">
.search-set {
    .el-range-separator {
        width: 16px;
    }
    .overflow-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-input__inner {
        height: 28px !important;
        padding: 3px 10px;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
    }

    .search-list-box {
        width: 100%;
        margin-top: 10px;
        max-height: 220px;
        overflow-y: scroll;
        display: flex;

        > li {
            width: 464px;
            margin-bottom: 10px;
            display: flex;

            > .label {
                display: inline-block;
                height: 28px;
                line-height: 28px;
                width: 120px;
                padding: 0 10px 0 0;
                text-align: right;
            }

            > .form-item {
                width: 400px;
                > div {
                    width: 100%;
                }
            }
            .select {
                width: 100px;
                margin-right: 6px;
            }
            .select-btn {
                color: #eee !important;
            }
            &.is-fussy {
                .el-input-group--append {
                    .el-input-group__append {
                        background-color: #fff;
                    }
                    .isActive {
                        background-color: #00bcbf;
                        color: #fff;
                    }
                }
                .form-item {
                    width: 260px;
                }
                .input-append-fussy {
                    width: 48px;
                    margin-top: 4px;
                    margin-left: 6px;
                    .el-checkbox__label {
                        padding-left: 4px;
                    }
                }
            }
        }
    }

    .line {
        height: 1px;
        width: 100%;
        background-color: #f2f2f2;
    }

    .search-total-box {
        max-height: 120px;
        overflow: auto;

        li {
            width: 162px;
            padding: 0 10px 10px 0;
        }
    }
    .btn-box1 {
        padding: 0px 40px;
        display: flex;
        justify-content: space-between;
    }
    .btn-box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        .text-btn {
            width: 40%;
        }
        .btn-btn {
            width: 60%;
            display: flex;
            justify-content: flex-end;
        }
    }

    .btn-width {
        width: 162px;
    }

    .text-box {
        position: relative;
        font-size: 12px;
        width: 100%;
    }
    .text-boxs {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        width: 100%;
        line-height: 28px;
        .text-input {
            width: 46%;
        }
    }
    .v-modal {
        z-index: 2000 !important;
    }
    .showState {
        padding-left: 40px;
    }
}
</style>
